import React from 'react';
import { cn } from '@/lib/utils';

export interface SwitchProps {
  id?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
  className?: string;
  'aria-label'?: string;
}

export const Switch: React.FC<SwitchProps> = ({
  id,
  checked,
  onCheckedChange,
  disabled = false,
  size = 'md',
  className,
  'aria-label': ariaLabel,
}) => {
  const isSm = size === 'sm';

  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) {
          onCheckedChange(!checked);
        }
      }}
      className={cn(
        'relative inline-flex shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        isSm ? 'h-4 w-7' : 'h-5 w-9',
        checked ? 'bg-primary' : 'bg-muted border border-border/80',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'pointer-events-none inline-block rounded-full bg-white shadow-xs transition-transform duration-200 ease-in-out',
          isSm ? 'h-3 w-3' : 'h-4 w-4',
          checked
            ? isSm
              ? 'translate-x-3.5'
              : 'translate-x-4.5'
            : isSm
              ? 'translate-x-0.5'
              : 'translate-x-0.5'
        )}
      />
    </button>
  );
};
